// utils/razorpayHelper.ts
import { razorPayProcessI } from "../Interface/Payment.interface";
import logo from "../Assets/logo.png"; // adjust if needed
import { AppDispatch } from "../App/store";
import { confirmPayment } from "../Action/payment.Action";


export const loadRazorpayScript = () => {
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });
};


export const openRazorpayCheckout = (
  response: any,
  proceedPayment: any,
  dispatch: AppDispatch
): Promise<string> => {
  return new Promise((resolve, reject) => {
    const options = {
      key: response.razorPayKey,
      amount: proceedPayment.amount,
      currency: response.currency || "INR",
      name: "Ganga Super Market",
      description: response.description || "Ganga Super Market",
      image: logo,
      order_id: response.orderId,

      handler: async (paymentResult: any) => {
        try {
          const confirmPaymentPayload: razorPayProcessI = {
            razorpay_order_id: paymentResult.razorpay_order_id,
            razorpay_payment_id: paymentResult.razorpay_payment_id,
            razorpay_signature: paymentResult.razorpay_signature,
          };

          const statusResponse = await dispatch(confirmPayment(confirmPaymentPayload)).unwrap();

          if (statusResponse === "Payment Successful") {
            resolve(statusResponse); // return this from the Promise
          } else {
            alert("Payment verification failed.");
            reject("Payment verification failed.");
          }
        } catch (error) {
          console.error("Error verifying payment:", error);
          reject(error);
        }
      },

      prefill: {
        name: proceedPayment.name,
        email: proceedPayment.email,
        contact: proceedPayment.phoneNumber,
      },

      notes: {
        address: proceedPayment.address,
      },

      theme: {
        color: "#DC3545",
      },
    };

    const rzp = new (window as any).Razorpay(options);
    rzp.open();
  });
};

